<template>
  <div class="actiontype-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('actiontype_edit')"/>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-alert-decagram</v-icon>{{$t('orderaction.types')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <ActionTypesFilterForm
                ref="filterForm"
                :values="filters"
                slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
              v-model="selected"
              :headers="headers"
              :items="items"
              :items-per-page.sync="options.itemsPerPage"
              :footer-props="footer"
              :loading="isLoading"
              :loading-text="$t('global.loading')"
              :options.sync="options"
              :server-items-length="totalItems"
              class="elevation-1"
              item-key="@id"
              @update:options="onUpdateOptions"
              @click:row="showHandler"
              @contextmenu:row="showHandlerExt"
          >

          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionTypesFilterForm from '../../components/actiontype/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'ActionTypeList',
  servicePrefix: 'ActionType',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionTypesFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('global.name'), value: 'name' },
        { text: this.$t('action_type.auto_create'), value: 'autoCreate'}
      ],
      selected: [],
      footer: {
        'itemsPerPageText': "",
      },
      options: {sortBy : ['name'], sortDesc : [false]}
    };
  },
  computed: {
    ...mapGetters('actiontype', {
      items: 'list'
    }),
    ...mapFields('actiontype', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('actiontype', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
